import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCodePullRequest } from '@fortawesome/free-solid-svg-icons'
import { statusMeta } from './blockChangeHelpers'

export default function BlocksViewModeBar({
  changeRequestId,
  draft,
  isClosed = false,
  myDrafts,
  onSelect,
}) {
  if (changeRequestId) {
    const changeRequest = draft?.change_request
    const meta = changeRequest ? statusMeta(changeRequest.status) : null
    return (
      <div
        className="lox-block-change__mode is-draft"
        data-testid="blocks-view-mode"
      >
        <strong>
          {isClosed ? '' : 'Draft '}CR-{changeRequestId}
          {changeRequest ? ` ${changeRequest.title}` : ''}
        </strong>
        {meta && (
          <span className={`tag lox-no-border ml-2 ${meta.tagClass}`}>
            {meta.label}
          </span>
        )}
        <span className="is-size-7 has-text-grey ml-2">
          {isClosed
            ? 'No longer a draft.'
            : 'Showing the tables as they would be after apply.'}
        </span>
        <button
          type="button"
          className="button is-small ml-3"
          onClick={() => onSelect(null)}
        >
          Back to live
        </button>
        <Link
          className="button is-small ml-2"
          to={`/lead_funnel_block_change_requests/${changeRequestId}`}
        >
          Review
        </Link>
      </div>
    )
  }

  const pick = (event) => {
    if (event.target.value) onSelect(Number(event.target.value))
  }

  return (
    <div className="lox-block-change__mode" data-testid="blocks-view-mode">
      <strong>Live</strong>
      {myDrafts.length > 0 && (
        <div className="select is-small">
          <select value="" onChange={pick} data-testid="blocks-draft-picker">
            <option value="">View one of my drafts…</option>
            {myDrafts.map((changeRequest) => (
              <option key={changeRequest.id} value={changeRequest.id}>
                CR-{changeRequest.id} {changeRequest.title}
              </option>
            ))}
          </select>
        </div>
      )}
      <span className="lox-block-change__mode-divider" aria-hidden="true" />
      <Link
        className="lox-block-change__mode-link"
        to="/lead_funnel_block_change_requests"
      >
        <FontAwesomeIcon icon={faCodePullRequest} className="mr-1" />
        Change requests
      </Link>
    </div>
  )
}
